import { RefObject } from 'react';
import {
  MAX_HEIGHT,
  MAX_WIDTH,
  MIME_TYPE,
  QUALITY,
} from '../constants/settings';

// function to compress image file declared here
export const compressImage = (
  imageFile: File,
  canvas: RefObject<HTMLCanvasElement>
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    if (imageFile.name.length > 100) {
      reject(
        new Error('Invalid file name! File name must be under 100 characters.')
      );
    }

    const blobURL = URL.createObjectURL(imageFile);

    const img = new Image();
    img.src = blobURL;

    img.onerror = function () {
      URL.revokeObjectURL(this.src);
      reject(new Error('Invalid image!!'));
    };

    img.onload = () => {
      let blobImage: Blob | null = null;

      URL.revokeObjectURL(img.src);

      const [newWidth, newHeight] = calculateImageSize(
        img,
        MAX_WIDTH,
        MAX_HEIGHT
      );

      if (canvas.current) {
        canvas.current.width = newWidth;
        canvas.current.height = newHeight;

        const ctx = canvas.current.getContext('2d');
        ctx?.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.current.toBlob(
          (blob) => {
            if (blob) {
              console.log(blob);
              resolve(blob);
            } else {
              reject(new Error('Failed to create blob!!'));
            }
          },
          MIME_TYPE,
          QUALITY
        );
      } else {
        reject(new Error('Canvas not available!!'));
      }

      return blobImage;
    };
  });
};

// function to calculate image size (width, height) declared here
export const calculateImageSize = (
  img: HTMLImageElement,
  maxWidth: number,
  maxHeight: number
) => {
  let width = img.width;
  let height = img.height;

  if (width > height) {
    if (width > maxWidth) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width = Math.round((width * maxHeight) / height);
      height = maxHeight;
    }
  }

  return [width, height];
};

// function to convert image file to base64 declared here
export const convertImageToBase64 = (image: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(image);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
